import { createHandlers } from '@redux-async-module/handlers-utils';
import { createReducer } from '@redux-basic-module/reducer-utils';

import { createUpdateDraft } from './actions';
import { INITIAL_STATE, NAMESPACE } from './types';

const HANDLERS = createHandlers(createUpdateDraft, INITIAL_STATE);

export const reducer = createReducer(NAMESPACE, INITIAL_STATE, HANDLERS);
